const DEFAULT_FALLBACK_BASE = 'https://gov-benefit.stg.3o3.co.kr/benefits';

export function benefitDetailUrl(serviceSeqNo: string): string {
  const raw =
    (import.meta.env.VITE_BENEFIT_DETAIL_BASE as string | undefined)?.trim() ||
    DEFAULT_FALLBACK_BASE;
  const base = raw.replace(/\/$/, '');
  return `${base}/${serviceSeqNo}`;
}

/**
 * Returns the serviceSeqNo if href matches the SPA route `/benefit/:id`, else undefined.
 * Used to detect taps that should open the benefit website in a new browsing context
 * (so the article WebView is preserved underneath in-app).
 */
export function tryGetBenefitServiceSeqNo(href: string): string | undefined {
  const match = href.match(/^\/benefit\/([^/?#]+)/);
  return match?.[1];
}
